export default __webpack_public_path__ + "static/media/faci16.f1145441.jpg";